// extracted by mini-css-extract-plugin
module.exports = {"noGraphData":"NoGraphData_noGraphData__3Cvxx"};